import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import trans from "../../utils";
import { Button, Space } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import ConsultantAlertsSummary from "./ConsultantDashboardParts/ConsultantAlertsSummary";
import ConsultantCharts from "./ConsultantDashboardParts/ConsultantCharts";
import ConsultantRequestsTable from "./ConsultantDashboardParts/ConsultantRequestsTable";

const ConsultantDashboard = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  // Auto-refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prev) => prev + 1);
      setLastUpdated(new Date());
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
    setLastUpdated(new Date());
  };

  return (
    <div>
      <Helmet>
        <title>Consultant Dashboard</title>
        <meta
          name="description"
          content="Consultant Dashboard for managing field operations, technicians, and service requests"
        />
      </Helmet>

      {/* Dashboard Header */}
      <div
        className="d-flex justify-content-between align-items-center mb-4 p-3"
        style={{ background: "#FFFFFFDE" }}
      >
        <div>
          <h2 className="fs-24 fw-700 neutral-800 mb-1">
            {trans("Consultant Dashboard")}
          </h2>
          <p className="fs-14 neutral-500 mb-0">
            {trans("Last updated:")} {lastUpdated.toLocaleTimeString()}
          </p>
        </div>
        <Space>
          <Button
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
            type="default"
          >
            {trans("Refresh")}
          </Button>
        </Space>
      </div>

      {/* Alert Summary - Top Priority */}
      <div style={{ background: "#FFFFFFDE" }} className="p-3">
        <div className="mb-4">
          <ConsultantAlertsSummary
            key={`consultant-alerts-${refreshKey}`}
            refreshKey={refreshKey}
          />
        </div>

        {/* Charts Section */}
        <div className="mb-4">
          <ConsultantCharts
            key={`consultant-charts-${refreshKey}`}
            refreshKey={refreshKey}
          />
        </div>

        {/* Latest Requests Table */}
        <div className="mb-4">
          <ConsultantRequestsTable
            key={`consultant-requests-${refreshKey}`}
            refreshKey={refreshKey}
          />
        </div>
      </div>
    </div>
  );
};

export default ConsultantDashboard;
